import api from "../../config/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../config/apiRoutes";


/**✅ getChatBot Thunk */
export const getChatBotThunk = createAsyncThunk(
    "chatBot/getChatBotThunk",
    async (payload = {}, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        // 👈 Skip API if data already in state
        if (payload.type !== "getBot") {
            if (state.chatBot?.getChatBotDetails?.length > 0) {
                return state.chatBot.getChatBotDetails;
            }
        }

        try {
            const response = await api.post(API_ROUTES.CHATBOT, {
                client_id: user?.client_id
            });

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch ChatBot");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);

/**✅ getBot Click HistoryThunk */
export const getChatBotClickHistoryThunk = createAsyncThunk(
    "chatBot/getChatBotClickHistoryThunk",
    async (credentials, { rejectWithValue }) => {
        try {
            const response = await api.post(API_ROUTES.CHATBOT_CLICK_HISTORY, credentials);

            const { message, statusCode, data } = response.data;

            if (statusCode === 200) {
                return data;
            }

            return rejectWithValue(message || "Failed to fetch ChatBot");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Request failed"
            );
        }
    }
);


export const createChatBotThunk = createAsyncThunk(
    "chatBot/createChatBotThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.CREATE_CHAT_BOT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);


export const editChatBotThunk = createAsyncThunk(
    "chatBot/editChatBotThunk",
    async ({ credentials }, { rejectWithValue, getState, dispatch }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.EDIT_CAHT_BOT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 200) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Login failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Login failed"
            );
        }
    }
);


export const deleteChatBotThunk = createAsyncThunk(
    "chatBot/deleteChatBotThunk",
    async ({ credentials }, { rejectWithValue, getState }) => {
        const state = getState();
        const user = state.authentication?.user;

        const payload = {
            ...credentials,
            employee_id: user?.user_id,
        };

        try {
            const response = await api.post(API_ROUTES.DELETE_CHAT_BOT, payload);
            const { message, statusCode } = response.data;

            if (statusCode === 201) {
                return {
                    success: true,
                    message,
                };
            }

            return rejectWithValue(message || "Bot deleted failed");
        } catch (error) {
            return rejectWithValue(
                error.response?.data?.message || error.message || "Bot Deleted failed"
            );
        }
    }
);
